import React from "react";
import Image from "next/image";
import Gal1 from "../public/gallery1.webp";
import Gal2 from "../public/gallery2.webp";
import Gal3 from "../public/gallery3.webp";
import Gal4 from "../public/gallery4.webp";
import Gal5 from "../public/gallery5.webp";

export default function GallerySection() {
    const images = [
        Gal3,
        Gal2,
        Gal5,
        Gal4,
        Gal1,
    ];

    const highlights = [
        "Expert-led counselling and admission guidance sessions",
        "Interactive Q&A with students and parents",
        "Real insights on college selection and choice filling",
    ];

    return (
        <section className="relative overflow-hidden  py-14 sm:py-16 lg:py-20">
            <div className="absolute left-0 top-0 h-52 w-52 rounded-full bg-[#ffe7d6]/60 blur-3xl" />
            <div className="absolute bottom-0 right-0 h-60 w-60 rounded-full bg-[#fff1e7] blur-3xl" />

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
                    <div className="max-w-xl">
                        <h2
                            className="text-center text-2xl font-bold capitalize sm:text-3xl"
                            style={{ color: "#140342" }}
                        >
                            Explore Our Seminar{" "}
                            <span className="text-[#ff9245]">Highlights</span>
                        </h2>

                        <p className="mx-auto mt-3 max-w-[520px] text-xs leading-5 text-slate-600 sm:text-lg sm:leading-6">
                            Take a closer look at our NEET counselling seminars, where
                            students and parents receive practical admission guidance,
                            expert mentoring, and clarity for smarter decision-making.
                        </p>

                        <div className="mt-7 space-y-3.5">
                            {highlights.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex items-start gap-3 rounded-2xl border border-[#f3dfd2] bg-white px-4 py-3 shadow-sm"
                                >
                                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#ff9245] text-xs font-bold text-white">
                                        ✓
                                    </span>
                                    <p className="text-sm leading-6 text-slate-700 sm:text-[15px]">
                                        {item}
                                    </p>
                                </div>
                            ))}
                        </div>

                        <div className="mt-8 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
                            <button className="rounded-full bg-[#ff9245] px-6 py-4 text-sm font-bold uppercase text-white">
                                View All Photos
                            </button>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 sm:gap-5">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className={`group relative overflow-hidden bg-white shadow-md ring-1 ring-black/5 ${index === 2
                                        ? "col-span-2 h-[240px] rounded-[26px] shadow-lg sm:h-[300px]"
                                        : "h-[200px] rounded-[22px] sm:h-[240px]"
                                    } ${index === 1 ? "sm:translate-y-8" : ""
                                    } ${index === 4 ? "sm:-translate-y-6" : ""
                                    }`}
                            >
                                {typeof image === "string" ? (
                                    <img
                                        src={image}
                                        alt={`Seminar highlight ${index + 1}`}
                                        className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                                    />
                                ) : (
                                    <Image
                                        src={image}
                                        alt={`Seminar highlight ${index + 1}`}
                                        fill
                                        sizes="(max-width: 768px) 50vw, 25vw"
                                        className="object-cover transition duration-500 group-hover:scale-105"
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}